import { render, staticRenderFns } from "./merchantIcon.vue?vue&type=template&id=ec065a1e&"
import script from "./merchantIcon.vue?vue&type=script&lang=js&"
export * from "./merchantIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports